<template>
  <div class="optionView">
    <p>
      <span>项目简称：</span>
      <span>{{ item.projectAbbreviate ? '【' + item.projectAbbreviate +'】' : '--' }}</span>
    </p>
    <p>
      <span>项目编号：</span>
      <span>{{ item.projectId || '--' }}</span>
    </p>
    <p v-if="item.projectType === 2">
      <span>项目代号：</span>
      <span>{{ item.projectCode || '--' }}</span>
    </p>
    <p>
      <span>创建人：</span>
      <span>{{ item.createBy || '--' }}</span>
    </p>
    <p>
      <span>项目管理员：</span>
      <span>{{
        item.projectHead && item.projectHead.name ? item.projectHead.name : '--'
      }}</span>
    </p>

    <template v-if="item.projectType === 1">
      <p>
        <span>客户编号：</span>
        <span>{{ item.customerId || '--' }}</span>
      </p>
      <p>
        <span>客户名称：</span>
        <span>{{ item.customer || '--' }}</span>
      </p>
    </template>

    <template v-if="item.projectType === 2">
      <p>
        <span>商机名称：</span>
        <span>{{ item.business || '--' }}</span>
      </p>
      <p>
        <span>客户名称：</span>
        <span>{{ item.customer || '--' }}</span>
      </p>
    </template>

    <template v-if="item.projectType === 3">
      <p>
        <span>产品线：</span>
        <span>{{ item.productLine || '--' }}</span>
      </p>
    </template>

    <template v-if="item.projectType === 4">
      <p>
        <span>预算部门：</span>
        <span>{{ item.budgetDepartment || '--' }}</span>
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'OptionView',
  components: {},
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {

    }
  },
  computed: {},
  watch: {},
  created() {

  },
  mounted() {

  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.optionView{
  height: auto;
  line-height: 22px;
  padding-bottom: 10px;
  padding-top: 10px;
}
</style>
